// extracted by mini-css-extract-plugin
module.exports = {"Media":"Media_Media__1REvR"};